import { useEffect, useState } from 'react';
import { subscribeToUserFlags, UserFlags } from '../services/users';

const DEFAULT_FLAGS: UserFlags = {
  isReviewer: false,
  isAdmin: false,
  isOwner: false,
};

interface UseUserFlagsResult extends UserFlags {
  loading: boolean;
}

export function useUserFlags(uid: string | null | undefined): UseUserFlagsResult {
  const [flags, setFlags] = useState<UserFlags>(DEFAULT_FLAGS);
  const [loading, setLoading] = useState(Boolean(uid));

  useEffect(() => {
    if (!uid) {
      setFlags(DEFAULT_FLAGS);
      setLoading(false);
      return undefined;
    }

    setLoading(true);

    return subscribeToUserFlags(
      uid,
      (nextFlags) => {
        setFlags(nextFlags);
        setLoading(false);
      },
      (error) => {
        console.error('[useUserFlags] failed to resolve flags', { uid, error });
        setFlags(DEFAULT_FLAGS);
        setLoading(false);
      }
    );
  }, [uid]);

  return {
    ...flags,
    loading,
  };
}
